import {SwitchTo} from "./SwitchTo";
import {PoweredBy} from "./PoweredBy";
import React from "react";
import {useAppSelector} from "../../app/hooks";
import {allowSMSSelector} from "../chatbotSlice";

export const WidgetFooter: React.FC = () => {

    const allowSMS = useAppSelector(allowSMSSelector)

    return <div className="flex justify-center flex-col pt-3 pb-1">
        <div className={`flex flex-row w-[100%] px-6 ${allowSMS ? 'justify-between' : 'justify-center'}`}>
            {allowSMS && <SwitchTo/>}
            <PoweredBy/>
        </div>
    </div>
}
